<template>
  <div id="package-creation-pricing">
    <binary
      option1="Hourly Rate"
      option2="Flat Rate"
      Heading="Price Type"
      :selected="selected"
      @toggle="changePriceType"
    />
    <Input
      class="scs-input"
      heading="Base Rate"
      placeholder="2000"
      type="number"
      :initialValue="baseRate"
      @scs-input="baseRateInput"
    />
    <Input
      class="scs-input"
      heading="Base Time (in hours)"
      :disabled="selected === 'Flat Rate'"
      placeholder="4"
      type="number"
      :initialValue="baseTime"
      @scs-input="baseTimeInput"
    />
    <Input
      class="scs-input"
      heading="Additional Hourly"
      placeholder="200"
      :disabled="selected === 'Flat Rate'"
      type="number"
      :initialValue="addHourly"
      @scs-input="addHourlyInput"
    />
  </div>
</template>
<script>
import Binary from "@/Components/Elements/Binary.vue";
import Input from "@/Components/Elements/Input.vue";
export default {
  data() {
    return {
      selected: "Hourly Rate",
      baseRate: undefined,
      baseTime: undefined,
      addHourly: undefined,
      priceOption: undefined,
    };
  },
  computed: {},
  methods: {
    baseRateInput(int) {
      this.baseRate = int;
      this.emitPricePackage();
    },
    baseTimeInput(int) {
      this.baseTime = int;
      this.emitPricePackage();
    },
    addHourlyInput(int) {
      this.addHourly = int;
      this.emitPricePackage();
    },
    changePriceType() {
      if (this.selected === "Hourly Rate") {
        this.selected = "Flat Rate";
      } else {
        this.selected = "Hourly Rate";
      }
      this.emitPricePackage();
    },
    emitPricePackage() {
      switch (this.selected) {
        case "Hourly Rate":
          if (this.baseRate && this.baseTime && this.addHourly) {
            let packagePricing = {
              pricing: {
                baseRate: this.baseRate * 100,
                baseTime: this.baseTime,
                addHourly: this.addHourly * 100,
              },
              priceOption: "Hourly",
            };
            this.$emit("pricing-input", packagePricing);
          }
          break;
        case "Flat Rate":
          if (this.baseRate) {
            let packagePricing = {
              pricing: {
                baseRate: this.baseRate * 100,
              },
              priceOption: "Flat",
            };
            this.$emit("pricing-input", packagePricing);
          }
          break;
      }
    },
  },
  created() {
    let { baseRate, addHourly, baseTime } = this.subject.pricing;
    let { priceOption } = this.subject;
    this.baseRate = baseRate;
    this.addHourly = addHourly;
    this.baseTime = baseTime;
    if (priceOption === "Hourly") {
      this.selected = "Hourly Rate";
    } else {
      this.selected = "Flat Rate";
    }
  },
  components: { Binary, Input },
  props: ["subject"],
  emits: ["pricing-input"],
};
</script>
<style scoped>
#package-creation-pricing {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 50px 50px;
}

.scs-input {
  width: 250px;
}
</style>
